import { render } from "./CreateNewEducSectionModal.vue?vue&type=template&id=0fb0ef88&scoped=true"
import script from "./CreateNewEducSectionModal.vue?vue&type=script&lang=js"
export * from "./CreateNewEducSectionModal.vue?vue&type=script&lang=js"

import "./CreateNewEducSectionModal.vue?vue&type=style&index=0&id=0fb0ef88&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb0ef88"]])

export default __exports__